import { animation } from "./_animation";
import { common } from "./_common";
import { slide } from "./_slide";
import { drawer } from "./_drawer";
import { header } from "./_header";
import { fv } from "./_fv";
import { swiper } from "./_swiper";


animation();
common();
slide();
drawer();
header();
fv();
swiper();